import PropTypes from 'prop-types';
import { Bike, Car, Truck } from 'lucide-react';

const VEHICLE_ICONS = {
  Bike,
  Scooter: Bike,
  Car,
  Van: Truck,
  Truck,
};

// Resolves a lucide icon for a delivery agent's vehicle string.
export const DeliveryVehicleIcon = ({ vehicle, size = 13, ...rest }) => {
  const Icon = VEHICLE_ICONS[vehicle] || Truck;
  return <Icon size={size} {...rest} />;
};

DeliveryVehicleIcon.propTypes = {
  vehicle: PropTypes.string,
  size: PropTypes.number,
};

export const VEHICLE_OPTIONS = ['Bike', 'Scooter', 'Car', 'Van', 'Truck'];
